import React, { useState } from "react";
import { FaSearch, FaCartPlus, FaTimes, FaBoxOpen, FaSpinner } from "react-icons/fa";
import useEscClose from "../../hooks/useEscClose";
import SearchBar from "../UI/SearchBar";
import { API_BASE } from "../../utils/api";
import { getMyAccountId, isBMI } from "../../utils/config";
export default function ProductSearchModal({ open, onClose, onSelect }) {
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const MYACCOUNT_ID = getMyAccountId();
  // ESC para cerrar
  useEscClose(open, onClose);

  if (!open) return null;

  const searchProducts = async () => {
    if (!keyword.trim()) return;

    setLoading(true);
    try {

      const response = await fetch(
        `${API_BASE}/inventary-ultra/api/ws/search_products_api?myaccount_id=${MYACCOUNT_ID}&bodega_id=${user.bodegaId}&id_customer=${user.idCustomer}&search=${keyword}&solo_acuerdo=${isBMI(user)}`
      );
      setResults(await response.json());
    } catch (error) {
      console.error("Error buscando productos:", error);
    }
    setLoading(false);
  };

  const handleKeyPress = (e) => e.key === "Enter" && searchProducts();


  return (
    <div className="fixed inset-0 z-[9999] flex">

      {/* PANEL IZQUIERDO FULL SCREEN */}
      <div
        className="
          w-full md:w-[500px]
          h-full bg-white shadow-2xl
          flex flex-col overflow-hidden
          animate-slideLeft
        "
      >
        {/* HEADER */}
        <div className="flex justify-between items-center px-6 py-8 border-b bg-gray-50">
          <h2 className="text-xl font-bold text-black tracking-wide">
            BÚSQUEDA DE PRODUCTOS
          </h2>

          <button
            className="text-gray-600 hover:text-black transition"
            onClick={onClose}
          >
            <FaTimes size={22} />
          </button>
        </div>

        {/* SEARCH BAR */}
        <SearchBar
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={handleKeyPress}
          onSearch={searchProducts}
          autoFocus
          variant="modal"

        />

        {/* RESULTS */}
        <div className="overflow-y-auto p-4 space-y-4">

          {/* LOADING */}
          {loading && (
            <div className="flex flex-col items-center mt-10 text-gray-600">
              <FaSpinner className="animate-spin" size={30} />
              <p className="mt-2">Buscando productos...</p>
            </div>
          )}

          {/* SIN RESULTADOS */}
          {!loading && results.length === 0 && (
            <div className="text-center text-gray-500 flex flex-col items-center mt-12">
              <FaBoxOpen size={50} className="opacity-40 mb-2" />
              <p>Sin resultados</p>
            </div>
          )}

          {/* LISTA */}
          {results.map((item) => (
            <div
              key={item.idProduct}
              className="flex items-center gap-5 border rounded-2xl p-6 shadow hover:shadow-lg transition cursor-default bg-white"
            >
              {/* Imagen */}
              <img
                src={`https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${item.productId}.jpg`}
                onError={(e) => (e.target.src = "/no-image.png")}
                className="w-44 h-44 object-cover shadow-md border rounded cursor-pointer hover:scale-110 transition"
              />

              <div className="flex-1">
                <h3 className="font-semibold text-gray-800">{item.productName}</h3>
                <p className="text-gray-500 text-sx">Código: {item.productId}</p>
                <p className="font-bold text-brand-primary text-2xl">
                  $ {Number(item.unitPrice).toFixed(4)}
                </p>
              </div>

              <button
                onClick={() => {
                  onSelect(item);
                  onClose();

                }}
                className="p-3 bg-brand-primary text-white rounded-full hover:brightness-90 transition shadow-md"
              >
                <FaCartPlus size={26} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* OVERLAY NEGRO (CLICK PARA CERRAR) */}
      <div
        className="flex-1 bg-black/40"
        onClick={onClose}
      ></div>
    </div>
  );
}
